import {
  Box,
  Button,
  ButtonAppearance,
  globalTheme,
  Icon,
  SideSheet,
  SideSheetBody,
  SideSheetFooter,
  SideSheetHeader,
  SideSheetSize,
  Text,
  useModalState,
} from '@bechtel/gds';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { SearchField } from '~/components/search-field';
import { ReqHeaderStyled } from './styled';

interface RequisitionHeaderProps {
  searchText: string;
  setSearchText: (cal: string) => void;
}

export const RequisitionHeader: FC<RequisitionHeaderProps> = ({ searchText, setSearchText }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { open, close, visible } = useModalState(false);
  return (
    <ReqHeaderStyled>
      <Box alignItems={{ sm: 'center' }}>
        <SearchField
          placeholder={t('SEARCH_BY_BUN_PLACEHOLDER')}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: '300px' }}
        />
        <Box px={{ sm: '500' }}>
          <Button appearance={ButtonAppearance.SECONDARY} onClick={() => open()}>
            <Icon icon="sliders" iconStyle="solid" color="grey.600" />
          </Button>
        </Box>

        {/* will be removed later discussion pending */}
        {/* <Box px={{ sm: '500' }}>
          <Select
            disabled={false}
            size={TextFieldSize.MEDIUM}
            appearance={TextFieldAppearance.NORMAL}
            items={[]}
            itemComponent={OptionItem}
            selectedComponent={OptionItem}
            initialSelectedItem={t('TOTAL_QTY_REQUESTED')}
            loading={false}
            onSelectedItemChange={({ selectedItem }) => {}}
          />
        </Box>
        <Box>
          <Select
            disabled={false}
            size={TextFieldSize.MEDIUM}
            appearance={TextFieldAppearance.NORMAL}
            items={[]}
            itemComponent={OptionItem}
            selectedComponent={OptionItem}
            initialSelectedItem={t('QTY_NEEDED')}
            loading={false}
            onSelectedItemChange={({ selectedItem }) => {}}
          />
        </Box> */}
      </Box>

      <Box>
        <Button appearance={ButtonAppearance.SECONDARY} onClick={() => navigate('/requisition')}>
          <Icon icon="nfc-symbol" style={{ marginRight: globalTheme.spacings[300] }} />
          <Text color="grey.700">{t('REQUISITION')}</Text>
        </Button>
      </Box>

      <SideSheet visible={visible} style={{ width: '35%' }} size={SideSheetSize.MEDIUM}>
        <SideSheetHeader title={t('FILTERS')} />
        <SideSheetBody></SideSheetBody>
        <SideSheetFooter>
          <Box justifyContent={{ sm: 'flex-end' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              {t('Close')}
            </Button>
            <Button appearance={ButtonAppearance.PRIMARY}>{t('SUBMIT')}</Button>
          </Box>
        </SideSheetFooter>
      </SideSheet>
    </ReqHeaderStyled>
  );
};
